export default __webpack_public_path__ + "static/media/155.e9f02ec6.jpg";